module.exports = __webpack_public_path__ + "media/images/icons/x_logo_invalid-d06cd1e487ba715a6cb9e4e2172d08af.svg";